export default __webpack_public_path__ + "static/media/avatar_43.b5fb6626.png";